import Vue from 'vue'
import { MIXIN_MODEL_FORM_DATA } from '@/mixins/form/mixinModelFormData'

const MIXIN_FORM = {
  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: false
    },

    isSending: {
      type: Boolean,
      required: false,
      default: false
    },

    clearOnDestroy: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  mixins: [MIXIN_MODEL_FORM_DATA],

  methods: {
    onSubmit (data) {
      this.$emit('request', data)
    },
    onCancel () {
      this.$emit('cancel')
    },

    clear () {
      for (const key in this.modelFormData) {
        Vue.set(this.modelFormData, key, null)
      }
    }
  }
}

export {
  MIXIN_FORM
}
